import { recordPath, recordRoute } from '@/shared/registry'

/** Where the user custom field pages live. */
export const userCustomFieldsPath = '/site-management/user-custom-fields'
export const createUserCustomFieldPath = `${userCustomFieldsPath}/new`
export const userCustomFieldRoute = recordRoute('site-management', 'user-custom-fields')
export const editUserCustomFieldRoute = `${userCustomFieldRoute}/edit`

/** A custom field's details page. */
export function userCustomFieldPath(id: string): string {
  return recordPath('site-management', 'user-custom-fields', id)
}

/** A custom field's Edit Custom Field page. */
export function editUserCustomFieldPath(id: string): string {
  return `${userCustomFieldPath(id)}/edit`
}

/** The base of Custom Field Details' slots (`detailsSlots`). */
export const userCustomFieldDetailsSlot = 'site-management.user-custom-field-details'

/** The API's custom field endpoints: a GET finds them, a POST creates one. */
export const userCustomFieldsApi = '/site-management/v1/user-custom-fields'

export function userCustomFieldApi(id: string): string {
  return `${userCustomFieldsApi}/${encodeURIComponent(id)}`
}

/** The enabled fields a person in the organization has, as Create and Edit User fill them in. */
export function availableUserCustomFieldsApi(organizationId: string): string {
  return `${userCustomFieldsApi}/available/${encodeURIComponent(organizationId)}`
}

/** A person's custom fields and values: GET reads them, PUT replaces the values. */
export function userCustomFieldValuesApi(userId: string): string {
  return `/site-management/v1/users/${encodeURIComponent(userId)}/custom-field-values`
}

/** What each custom field action needs: the definitions by their organization, the values by their person. */
export const readUserCustomFieldsPermission = 'site-management.user-custom-fields.read'
export const writeUserCustomFieldsPermission = 'site-management.user-custom-fields.write'
export const readUserCustomFieldValuesPermission = 'site-management.user-custom-fields.values.read'
export const writeUserCustomFieldValuesPermission = 'site-management.user-custom-fields.values.write'
